<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <!-- 卡片主体(表单) -->
          <div class="md-layout card-form">
            <!-- 选择查询类型 -->
            <div class="md-layout-item md-size-15 left-layout-item md-xsmall-size-50">
              <md-field>
                <!-- <label>MAC / UID</label> -->
                <md-select v-model="searchForm.searchType">
                  <md-option value="1">{{$I18n('dev_snid')}}</md-option>
                  <md-option value="2">{{$I18n('user_id')}}</md-option>
                  <md-option value="3">{{$I18n('app_id')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 查询的值 -->
            <div class="md-layout-item md-size-15 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{searchName}}</label>
                <md-input
                  v-model="searchForm.searchValue" 
                />
              </md-field>
            </div>
            <!-- 状态 (select) -->
            <div class="md-layout-item md-size-15 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("state")}}</label>
                <md-select v-model="searchForm.state">
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option value="1">{{$I18n('is_useing')}}</md-option>
                  <md-option value="2">{{$I18n('overdue')}}</md-option>
                  <md-option value="3">{{$I18n('un_use')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 绑定状态 (select) -->
            <div class="md-layout-item md-size-15 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("bind_state")}}</label>
                <md-select 
                  id="state"
                  name="state"
                  v-model="searchForm.state" 
                >
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option value="1">{{$I18n('binding')}}</md-option>
                  <md-option value="2">{{$I18n('un_binding')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 创建时间 (date) -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field class="md-theme-default md-has-value">
                <!-- <label>{{$I18n("create_time")}}</label> -->
                <el-date-picker
                  v-model="searchForm.create_time"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  :start-placeholder="$I18n('start')"
                  :end-placeholder="$I18n('end')"
                  class="md-date-form-item"
                  align="left"
                  type="daterange"
                  prefixIcon="no"
                  range-separator="~"
                >
                </el-date-picker>
              </md-field>
            </div>
            <div class="md-layout-item left-layout-item md-size-20">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>{{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片主体(表格) -->
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item right-layout-item">
              <md-button class="left-icon md-info" @click="form_importTableModel">
                {{$I18n("unbind")}}
              </md-button>
              <md-button class="left-icon md-info" @click="form_giftTableModel">
                {{$I18n("gift_package")}}
              </md-button>
            </div>
          </div>
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('app_id')">{{ item.app_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_snid')">{{ item.uid }}</md-table-cell>
              <md-table-cell :md-label="$I18n('channel')">{{ item.channel }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('bind_state')">{{ item.bind_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('start_time')">{{ item.start_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('end_time')">{{ item.end_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.oss_create_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <md-card-actions v-if="total > 0" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              {{$I18n("total" )}} : {{total}}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            type= "info"
            v-model="currentPage"
            :per-page="pageSize"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <modal v-show="openModal" @close="modal_classicModalHide" type="rightModal">
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <template v-if="modalType == 'bind'" >
          <!-- 解绑弹窗 -->
          <div >
            <!-- 选择公司ID -->
            <modal-form-item :label='$I18n("user_id")'>
              <md-field :class="{'md-error' : false}">
                <md-input 
                  v-model="modalSearch.user_id"
                />
                <md-icon v-if="false">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 选择文件 -->
            <modal-form-item :label='$I18n("dev_snid")'>
              <md-field>
                <md-input 
                  v-model="modalSearch.uid"
                />
                <md-icon v-if="false">clear</md-icon>
              </md-field>
            </modal-form-item>
          </div>
          <div class="right-layout-item">
            <md-button class="md-info" @click="api_getModalTableData">{{$I18n("search")}}</md-button>
          </div>
          <div>

            <md-table v-if="modalType == 'bind'"  v-model="modalTableData" class="left-table">
              <md-table-row slot="md-table-row" slot-scope="{item}">
                <md-table-cell v-if="modalType == 'bind'" :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
                <md-table-cell v-if="modalType == 'bind'" :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
                <md-table-cell v-if="modalType == 'bind'" :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
                <md-table-cell v-if="modalType == 'bind'" :md-label="$I18n('create_time')">{{ item.oss_create_time }}</md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">
                {{$I18n("none_data")}}
              </md-table-empty-state>
            </md-table>
          </div>
        </template>
        <template v-else>
          <!-- 解绑弹窗 -->
          <div>
            <modal-form-item :label='$I18n("bind_user_id")' :required="true">
              <md-field :class="{'md-error' : false}">
                <md-input 
                  v-model="modalSearch.user_id"
                />
                <md-icon v-if="false">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 选择公司ID -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="sel_comp_id">
                  <md-option v-for="item in comp_list" :value="item.comp_id" :key="item.comp_id">{{item.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- APPID -->
            <modal-form-item :label='"APP"' :required="true">
              <md-field :class="{'md-error' : false}">
                <md-select v-model="modalSearch.app_base_id">
                  <md-option value="" :disabled="true">{{$I18n("pls_select")}}</md-option>
                  <md-option v-for="item in appBase" :value="item.id" :key="item.id">{{item.name}}</md-option>
                </md-select>
                <md-icon v-if="false">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- APPID -->
            <modal-form-item :label='$I18n("app_plat")' :required="true">
              <md-field :class="{'md-error' : false}">
                <md-select v-model="modalSearch.app_id">
                  <md-option value="" :disabled="true">{{$I18n("pls_select")}}</md-option>
                  <md-option v-for="item in appDetail" :value="item.app_id" :key="item.app_id">{{item.client_name}}</md-option>
                </md-select>
                <md-icon v-if="false">clear</md-icon>
              </md-field>
            </modal-form-item>


            <!-- 选择文件 -->
            <modal-form-item :label='$I18n("dev_snid")' :required="true">
              <md-field>
                <md-input 
                  v-model="modalSearch.uid"
                />
                <md-icon v-if="false">clear</md-icon>
              </md-field>
            </modal-form-item>
          </div>
          <div class="right-layout-item">
            <md-button class="md-info" @click="api_getModalGoodTableData">{{$I18n("search_good")}}</md-button>
          </div>
          <div>
            <md-table class="left-table">
              <md-table-empty-state slot="md-table-empty-state">
                {{$I18n("none_data")}}
              </md-table-empty-state>
            </md-table>
            <md-table v-if="modalType == 'gift'"  v-model="modalTableData" class="left-table">
              <md-table-row slot="md-table-row" slot-scope="{item}">
                <md-table-cell v-if="modalType == 'gift'" :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
                <md-table-cell v-if="modalType == 'gift'" :md-label="$I18n('cost')">{{ item.comp_price }}</md-table-cell>
                <md-table-cell v-if="modalType == 'gift'" :md-label="$I18n('good_price')">{{ item.rmb_fact_price }}</md-table-cell>
                <md-table-cell v-if="modalType == 'gift'" :md-label="$I18n('utility_time')">{{ item.month }}{{$I18n("a_month")}}</md-table-cell>
                <md-table-cell v-if="modalType == 'gift'" :md-label="$I18n('operate')"  class="button-box">
                  <md-button @click="modal_sendGood(item)" @click.stop class=" md-info left-icon" :style="{ 'width': 'auto' , 'height': '32px'}">
                    <!-- <md-icon>edit</md-icon> -->
                    {{$I18n("gift")}}
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">
                {{$I18n("none_data")}}
              </md-table-empty-state>
            </md-table>
          </div>
        </template>
      </template>
      <template slot="footer">
        <md-button class="md-info" v-if="modalType == 'bind'" @click="modal_submit">{{$I18n("unbind")}}</md-button>
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>

    <modal v-show="openUnbindModal" @close="modal_unbind_classicModalHide">
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_unbind_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div >
          {{$I18n("you_will_delete")}}
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info" @click="modal_unbind">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_unbind_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
    <modal v-show="openGiftModal" @close="modal_gift_classicModalHide">
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_gift_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div >
          {{$I18n("is_sure_send", goodInfo.name)}}
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info" @click="modal_gift">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_gift_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>

  </div>
</template>
<script>
import { Pagination } from "@/components";
import { Modal } from '@/components';
// import xlsxExpand from "@/common/xlsx";
export default {
  components: {
    Pagination,
    Modal,
    // Tree,
  },
  data() {
    return {
      comp_list: [],
      sel_comp_id: this.UserInfo.comp_id,
      appBase  :[],
      appDetail:[],
      goodInfo:{},
      userInfo:{},
      openGiftModal : false,

      modalType : "",
      openUnbindModal : false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      // 查询表单用的数据
      searchForm : {
        searchType : "1",
        searchValue: "",
        create_time:"",

        state       : 0, 
        uid         : "",
        user_id     : "",
        app_id      : "",
        start_time  : "",
        end_time    : "",
        bind        : 0,
        app_ids     : [],
      },
      searchData: {},
      // 表格相关
      icon  : "dns",
      title : "", //this.$I18n("order_info"),
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModal: false,
      modalTitle : "",
      modalSearch : {
        state       : 0, 
        app_base_id : "",
        app_id      : "",
        uid         : "",
        user_id     : "",
        start_time  : "",
        end_time    : "",
        bind        : 0,
        app_ids     : [],
      },
      modalInitTableData : [],
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getApp();
    this.api_getComp();
  },
  watch: {
    sel_comp_id(){
      this.api_getApp().then(() => {
        this.modalSearch.app_base_id = "";
        this.modalSearch.app_id = "";
      })
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    'modalSearch.app_base_id':{
      handler(value){
        if(value){
          this.api_getAppDetail(value);
        }
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 弹窗内表格数据
    modalTableData (){
      if(this.modalType == 'bind'){
        return this.modalInitTableData
          .filter(item => parseInt(item.state) !== 2)
          .map(item => {
            let res = {...item};
            switch(parseInt(item.state)){
              case 1: 
                res.state_name = this.$I18n("is_useing")
                break;
              case 2: 
                res.state_name = this.$I18n("overdue")
                break;
              case 3: 
                res.state_name = this.$I18n("un_use")
                break;
              default : 
                res.state_name = this.$I18n("unknow")
                break;
            }
            return res
          });
      } else {
        return this.modalInitTableData
        .map(item => {
          return {
            ...item,
            attrs: item.attr ?JSON.parse(item.attr) :{},
          }
        })
        .filter(item => {
          return item.month && item.attrs.lifecycle
        })
      }
    },
    // 选择查询的内容的名字
    searchName () {
      switch(this.searchForm.searchType){
        case "1":
          return this.$I18n("dev_snid");
        case "2":
          return this.$I18n("user_id");
        case "3":
          return this.$I18n("app_id");
        default:
          return this.$I18n("unknow")
      }
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          let state_name = "";
          switch(parseInt(item.state)){
            case 1: 
              state_name = this.$I18n("is_useing")
              break;
            case 2: 
              state_name = this.$I18n("overdue")
              break;
            case 3: 
              state_name = this.$I18n("un_use")
              break;
            default : 
              state_name = this.$I18n("unknow")
              break;
          }
          let bind_name = "";
          switch(parseInt(item.bind)){
            case 1: 
              bind_name = this.$I18n("binding");
              break;
            case 2: 
              bind_name = this.$I18n("un_binding");
              break;
            default : 
              bind_name = this.$I18n("unknow");
              break;
          }
          let type_name = this.$Param.orderTypeList.getName(item.order_type, "");
          if(type_name){
            type_name = this.$I18n(type_name);
          }
          return {
            ...item,
            type_name,
            state_name,
            bind_name,
            start_time: item.oss_start_time ? item.oss_start_time.split(" ")[0] :"",
            end_time  : item.oss_end_time ?item.oss_end_time.split(" ")[0] :"",
          }
        });
      }
    },
  },
  methods: {
    api_getComp(){
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.comp_list = res.data;
          if(!this.comp_list.some(i => i.comp_id === this.sel_comp_id)){
            this.sel_comp_id = this.comp_list[0].comp_id;
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.comp_list = [];
        }));
    },
    api_getApp(){ // API-获取APP列表
      return this.$api.queryAppBase({ // api: /user/app/query
        comp_id   : this.sel_comp_id,
        page_no   : 1,
        page_size : 9999,
      })
        .then(this.$Then(res => {
          this.appBase = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.appBase = [];
        }))
    },
    api_getAppDetail(id){ // API-获取APP的详细数据
      return this.$api.queryAppDetail({ // api: /user/app/detail/query
        id : id,
      })
        .then(this.$Then(res => {
          this.appDetail = res.data.map(item => {
            let client_name = "";
            switch(item.client_type){
              case 6:
                client_name = this.$I18n("web")
                break
              case 3:
                client_name = this.$I18n("android")
                break
              case 2:
                client_name = this.$I18n("ios")
                break
              case 4:
                client_name = this.$I18n("mac")
                break
              case 5:
                client_name = this.$I18n("ipad")
                break
              case 1:
                client_name = this.$I18n("pc")
                break
              case 0:
              default:
                client_name = this.$I18n("unknow")
                break
            }
            return {
              ...item,
              client_name,
            }
          })
          this.modalSearch.app_id = "";
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.appDetail = [];
          this.modalSearch.app_id = "";
        }))
    },
    api_getModalGoodTableData(){
      if(!this.modalSearch.uid || !this.modalSearch.user_id || !this.modalSearch.app_id){
        this.$errorMsg(this.$I18n("illegal_param"));
        return;
      }
      this.$api.getFeedbackDevice({
        uid     : this.modalSearch.uid,
        category_id: 101,
      })
        .then(this.$Then(res => {
          if(res.data.length == 0){
            this.userInfo = {};
            return 
          }
          if(res.data[0].attr){
            this.userInfo = {
              ...res.data[0],
              ...JSON.parse(res.data[0].attr),
            }
          } else {
            this.userInfo = {
              ...res.data[0],
            }
          }
          const compInfo = this.comp_list.filter(i => i.comp_id == this.sel_comp_id)[0];
          var path = ""
          if(compInfo){
            path = compInfo.path;
          }
          // 获取绑定的信息
          this.$api.getGood({
            pk        : this.userInfo.pk,
            app_id    : this.modalSearch.app_id,
            comp_id   : this.sel_comp_id,
            comp_path : path,
            spec_type : 1,
            link_type : 0,
          })
            .then(this.$Then(goodRes => {
              this.modalInitTableData = goodRes.data;
            }))
            .catch(this.$Catch(this.$I18n("get_error"), () =>{
              this.modalInitTableData = [];
            }));
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.userInfo = {};
          this.modalInitTableData = [];
        }))
    },
    // 根据查询内容获得对应的绑定的数据
    api_getModalTableData () {
      if(!this.modalSearch.uid ){
        this.$errorMsg(this.$I18n("pls_input_dev_snid"));
        return;
      }
      if(!this.modalSearch.user_id){
        this.$errorMsg(this.$I18n("pls_input_userid"));
        return;
      }
      // 获取绑定的信息
      this.$api.getUserCloudInfo({
          ...this.modalSearch,
      })
        .then(this.$Then(res => {
          this.modalInitTableData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalInitTableData = [];
        }))
    },
    // 改变检索条件,重置页面为1(并重新查询)
    form_changeSearchData(){
      this.searchData = {
        state      : this.searchForm.state, 
        uid        : "",
        user_id    : "",
        app_id     : "",
        start_time : this.searchForm.create_time ?this.searchForm.create_time[0] :"",
        end_time   : this.searchForm.create_time ?this.searchForm.create_time[1] :"",
        bind       : this.searchForm.bind,
      }
      switch(this.searchForm.searchType){
        case "1":
          this.searchData.uid = this.searchForm.searchValue;
          break;
        case "2":
          this.searchData.user_id = this.searchForm.searchValue;
          break;
        case "3":
          this.searchData.app_id = this.searchForm.searchValue;
          break;
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    // 获取页面信息
    api_getPageData(){
      // 云存储订单信息
      this.$api.getUserCloudInfo({
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 打开弹窗
    form_importTableModel () {
      this.modalTitle = this.$I18n("unbind");
      this.modalType = "bind";
      this.modalInitTableData = [];
      this.modalSearch = {
        user_id : "",
        uid : "",
      };
      this.openModal = true;
    },
    form_giftTableModel(){
      this.modalTitle = this.$I18n("gift_package");
      this.modalType = "gift";
      this.modalInitTableData = [];
      this.userInfo = {};
      this.modalSearch = {
        user_id    : "",
        app_base_id: "",
        app_id     : "",
        uid        : "",
      };
      this.openModal = true;
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      if (!this.openUnbindModal){
        this.openModal = false;
        this.modalType = "";
        this.modalInitTableData = [];
      }
    },
    // 提交表单
    modal_submit () {
      if (this.modalTableData.length === 0){
        this.$errorMsg(this.$I18n("no_dev_unbind"));
      } else {
        this.openUnbindModal = true;
      }
    },
    //
    modal_sendGood(item){
      this.goodInfo = {...item}
      this.openGiftModal = true;
    },
    modal_gift_classicModalHide (){
      this.openGiftModal = false;
    },
    modal_gift(){
      this.$api.pushPayList({
        name    : this.goodInfo.name,
        user_id : this.modalSearch.user_id,
        app_id  : this.modalSearch.app_id,
        uid     : this.modalSearch.uid,
        spec_id : this.goodInfo.id,
        buy_num : 1,
        pay_type: 4,
        fee_type: 2,
        channel : 1,
      })
        .then(this.$Then(res => {
          this.$api.setPaymentOrder({
            comp_price   : res.data.comp_price,
            pay_order_id : res.data.pay_order_id,
            order_key    : res.data.order_key,
            order_name   : res.data.order_name,
            order_fee    : res.data.order_fee,
            timestamp    : res.data.timestamp,
            order_notify_url : res.data.order_notify_url,
            user_id : this.modalSearch.user_id,
            app_id  : this.modalSearch.app_id,
            uid     : this.modalSearch.uid,
            type     : 4,
            fee_type : 2,
          })
            .then(this.$Then(() => {
              let count = 0;
              var sendCheckInfo = () => {
                this.$api.getOrderInfo({
                  pay_id: res.data.pay_order_id,
                })
                  .then(this.$Then(order_res => {
                    if(order_res.code != 200 || order_res.data.length == 0 || order_res.data[0].order_state != 1){
                      throw new Error ("Request failed, CDOE: " + order_res.code)
                    }
                    this.$successMsg(this.$I18n("send_succ"))
                    this.openGiftModal = false;
                    this.openModal = false;
                    this.modalType = "";
                    this.modalInitTableData = [];
                  }))
                  .catch(err => {
                    console.error(err)
                    count = count + 1
                    if(count <= 10){
                      setTimeout(sendCheckInfo, 200)
                    } else {
                      this.$errorMsg(this.$I18n("send_fail"));
                    }
                  })
              }
              sendCheckInfo()
            }))
            .catch(this.$Catch(this.$I18n("send_fail")))
        }))
        .catch(this.$Catch(this.$I18n("send_fail")))
    },
    modal_unbind (){
      let user_ids = [];
      let uid      = "";
      this.modalTableData.forEach(item => {
        if(!user_ids.includes(item.user_id)){
          user_ids.push(item.user_id);
        }
        uid = item.uid
      })
      let success = 0;
      user_ids.forEach(user_id => {
        this.$api.unbindCS({
          user_id,
          uid,
          type : 2,
          category_id : "101",
        })
          .then(this.$Then(() => {
            success = success + 1;
            if(success == user_ids.length){
              this.openModal = false;
              this.modalType = "";
              this.modalInitTableData = [];
              this.openUnbindModal = false;
              this.$successMsg(this.$I18n("unbind_success"));
            }
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      })
    },
    modal_unbind_classicModalHide (){
      this.openUnbindModal = false;
      this.api_getPageData();
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-table {
    text-align: left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    margin-right : 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
